import { Dict } from '../../../model/dict';

export function getYearValuesFromDict(
  dict: Dict<number>,
  years: number[],
  requireAtLeastOneDefinedValue: boolean = false
): (number | undefined)[] | undefined {
  const values = years.map((year) => {
    return dict[year];
  });

  if (requireAtLeastOneDefinedValue && !values.some((v) => v !== undefined)) {
    return undefined;
  }
  return values;
}
